<template>
    <div class="">
        <h1>NOT FOUND</h1>
    </div>
</template>
<script>
    export default {
        name: 'not-found',
        components: {},
    }
</script>
